import styled from "styled-components";
import { getThemeColor } from "../../Helpers/themes";

const ThemeColor = styled.span`
  color: ${({ theme, variant, shade }) => getThemeColor(theme, variant, shade)};
`;

export default ThemeColor;
